import { Link, useLocation } from "react-router-dom";
import { BookOpen, Lightbulb } from "lucide-react";
import { Sheet, SheetClose, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { guideFor } from "@/lib/guides";
import { GuideMockup } from "@/components/GuideMockup";

export const GuideBody = ({ guide }) => <div className="guide-body">
  <GuideMockup title={guide.title} />
  <ol className="guide-steps">{guide.steps.map((s, i) => <li key={i} data-testid={`guide-step-${i}`}><span>{i + 1}</span><p>{s}</p></li>)}</ol>
  {guide.tips.map((t, i) => <p className="guide-tip" key={i}><Lightbulb size={15} />{t}</p>)}
</div>;

export const GuideButton = () => {
  const guide = guideFor(useLocation().pathname);
  return <Sheet>
    <SheetTrigger asChild><button className="guide-btn" data-testid="page-guide-button"><BookOpen size={15} /><span>Guide</span></button></SheetTrigger>
    <SheetContent className="guide-sheet" data-testid="page-guide-panel">
      <SheetHeader><span className="eyebrow">{guide.group} · user guide</span><SheetTitle data-testid="page-guide-title">{guide.title}</SheetTitle><SheetDescription>{guide.intro}</SheetDescription></SheetHeader>
      <GuideBody guide={guide} />
      <SheetClose asChild><Link to="/help" className="guide-all" data-testid="page-guide-help-center">All guides in the Help Center</Link></SheetClose>
    </SheetContent>
  </Sheet>;
};
